<template>
  <div>
    <page-title title="Editar" :moduleIdentifier="identifier"/>

    <loader v-if="fetching || attribute === undefined || attribute === null || loadingCategories || savingAttribute"/>

    <panel v-else-if="attribute">
      <form-group label="Nome" :columns="12">
        <input type="text" v-model="attribute.label" class="form-input">
      </form-group>

      <form-group :label="$t('typeSelection.label')" :columns="12">
        <select v-model="attribute.typeSelection" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="typeSelectionOption in typeSelectionOptions" :value="typeSelectionOption">{{ $t(`typeSelection.${typeSelectionOption}.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Opções" v-if="isTypeWithOptions" :columns="12">
        <vue-tags-input
          class="form-input"
          v-model="attribute.options"
          :tags="options"
          :separators="[',']"
          :add-on-key="[',']"
          placeholder=""
          :allow-edit-tags="true"
          @tags-changed="newOptions => options = newOptions"/>

        <small class="form-help">Utilize vírgula (,) para múltiplas opções.</small>
      </form-group>

      <form-group label="Categorias" :columns="12">
        <multiselect
          v-model="categoriesSelect"
          :options="marketplaceCategories"
          label="label"
          track-by="code"
          selectLabel=""
          selectedLabel=""
          :multiple="true"
          placeholder="Todas"
        />
      </form-group>
    </panel>

    <panel>
      <button :disabled="savingAttribute" v-bind:class="{ 'is-loading': savingAttribute }" class="btn btn--success" @click="save">
        {{ $t('save.label') }}
      </button>
    </panel>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import { mapFields } from 'vuex-map-fields'
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import VueTagsInput from '@johmun/vue-tags-input'

  export default {
    data: () => ({
      attribute: null,
      categoriesSelect: [],
      loadingCategories: true,
      marketplaceCategories: [],
      options: [],
      typeSelectionOptions: [
        'select',
        'text',
        'multipleSelect'
      ]
    }),
    props: {
      identifier: {
        type: String,
        required: true
      },
      attributeId: {
        type: String,
        required: true
      }
    },
    mounted () {
      this.fillAttribute()
        .finally(() => this.getCategories())
    },
    methods: {
      ...mapActions('marketplaceAttribute', [
        'saveAttribute',
        'retrieveAttribute'
      ]),
      getCategories () {
        this.loadingCategories = true
        api.getCategories('marketplace', this.identifier)
          .then(categories => {
            this.marketplaceCategories = categories

            this.fillCategories()
          })
          .catch(() => {
            notifier.error('Erro ao buscar as categorias do marketplace.', 'Erro')
          })
          .finally(() => {
            this.loadingCategories = false
          })
      },
      async fillAttribute () {
        return this.retrieveAttribute({attributeId: this.attributeId, identifier: this.identifier})
          .then(() => {
            this.attribute = this.getAttribute(this.attributeId)

            if (this.attribute.options !== null) {
              for (let i in this.attribute.options) {
                const option = this.attribute.options[i]
                this.options.push({ text: option, tiClasses: ['ti-valid'] })
              }
            }

            this.attribute.options = ''
          })
      },
      fillCategories () {
        if (this.attribute === null || this.attribute === undefined || !this.marketplaceCategories.length) {
          return false
        }

        for (let i in this.attribute.categories) {
          const categoryCode = this.attribute.categories[i]

          const category = this.marketplaceCategories.find(category => category.code === categoryCode)
          if (category !== undefined) {
            this.categoriesSelect.push(category)
          }
        }
      },
      save () {
        const attribute = cloneDeep(this.attribute)

        const options = []
        for (let i in this.options) {
          options.push(this.options[i].text)
        }

        attribute.options = options

        this.saveAttribute({ attribute, identifier: this.identifier })
      }
    },
    computed: {
      ...mapFields({
        fetching: 'marketplaceAttribute.fetching',
        savingAttribute: 'marketplaceAttribute.saving'
      }),
      ...mapGetters('marketplaceAttribute', [
        'getAttribute'
      ]),
      isTypeWithOptions () {
        const selectTypes = ['select', 'multipleSelect']

        return selectTypes.indexOf(this.attribute.typeSelection) !== -1
      }
    },
    watch: {
      categoriesSelect (categories) {
        this.attribute.categories = categories.map(category => category.code)
      }
    },
    components: {
      PageTitle,
      Panel,
      FormGroup,
      Multiselect,
      VueTagsInput,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .vue-tags-input
    max-width: none
</style>



// WEBPACK FOOTER //
// Edit.vue?b30c0588